<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о взыскателе (заявителе)
        </div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicant"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        statement.subjects.previousCreditors &&
        statement.subjects.previousCreditors.length > 0
      "
    >
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о предыдущих кредиторах
        </div>
        <div>
          <Step2 :data="statement.subjects.previousCreditors" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.subjects.debtor">
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о должнике</div>
        <div>
          <Step3 :statement="statement" :subject="statement.subjects.debtor" />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        statement.subjects.previousDebtors &&
        statement.subjects.previousDebtors.length > 0
      "
    >
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о предыдущих должниках
        </div>
        <div>
          <Step4 :data="statement.subjects.previousDebtors" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.noticesRecoveryStep5">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Вид документа, на основании которого совершается исполнительная
          надпись
        </div>
        <div>
          <Step5 :data="statement.noticesRecoveryStep5" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.noticesRecoveryStep6">
      <v-col cols="12">
        <div class="form-base__title step-name">Параметры заявления</div>
        <div>
          <Step6 :data="statement.noticesRecoveryStep6" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.noticesRecoveryStep7">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>
        <div>
          <StepRequisites
            :data="statement.noticesRecoveryStep7"
            :statement-type="StatementType.NOTICE_RECOVERY"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о месте совершения нотариального действия
        </div>
        <div>
          <StepSign :data="statement.locationStep" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/NoticeRecovery/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/NoticeRecovery/Step3';
import Step4 from '@/components/elements/statement/FullStatementView/steps/NoticeRecovery/Step4';
import Step5 from '@/components/elements/statement/FullStatementView/steps/NoticeRecovery/Step5';
import Step6 from '@/components/elements/statement/FullStatementView/steps/NoticeRecovery/Step6';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'NoticeRecovery',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    StepSign,
    StepRequisites,
    Step6,
    Step5,
    Step4,
    Step3,
    Step2,
    Subject,
  },
  data: () => ({
    StatementType,
  }),
};
</script>

<style scoped></style>
